import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import AppPageHeader from '../../components/AppPageHeader'
import {
  Avatar,
  Button,
  Divider,
  Dropdown,
  Menu,
  message,
  Spin,
  Tabs,
} from 'antd'
import { inject, observer } from 'mobx-react'
import DashboardLayout from '../../layouts/DashboardLayout'
import PageTitle from '../../components/PageTitle'
import MyFirstGrid from './MyFirstGrid'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent/SpinnerInlineComponent'
import { ACL_ACTION_TYPE } from '../../constants'
import AccessControlAction from '../../components/AccessControlAction'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import { TinTucRequest } from '../../requests/TinTucRequest'
import {
  AddCircleOutlineIcon,
  MenuDotsBoldIcon,
  Pen2OutlineIcon,
  TrashBin2OutlineIcon,
} from '../../components/AppIcon'
import EmptyContent from '../../components/EmptyContent'
import {
  TextWrap,
  trimOverlengthString,
  WordBreak,
} from '../../components/Common/CellText'
import { blue } from '../../color'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import utils from '../../utils'
import { OverlayPanelWrapper } from '../../components/Overlays/OverlayPanelWrapper'
import AddEditNotificationModalV2 from './AddEditNotificationModalV2'

const { TabPane } = Tabs

const TinTucPage = props => {
  const ref = useRef(null)
  let [width, setWidth] = useState(0)

  const { loadingAnimationStore, tintucStore, history, aclStore } = props
  // const { newsList, tinTucTotalCount } = tintucStore

  const [isLoadingTinTuc, setIsLoadingTinTuc] = useState(true)
  const [newsList, setNewsList] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = useState(1)

  const [editingNotificationId, setEditingNotificationId] = useState(null)

  const [selectedKey, setSelectedKey] = useState(null)

  const loadTinTuc = useCallback(async () => {
    try {
      setIsLoadingTinTuc(true)

      const result = await TinTucRequest.getAllNews(page - 1, 10)

      setNewsList(result?.data?.data || [])
      setTotalCount(result?.data?.total_count || 0)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoadingTinTuc(false)
    }
  }, [page])

  useEffect(() => {
    setWidth(ref.current ? ref.current.offsetWidth : 0)
  }, [ref.current])

  useEffect(() => {
    loadTinTuc()
  }, [loadTinTuc])

  const onItemClick = tinTuc => {
    // history.push(`/general-notifications/update/${tinTuc.id}`)
  }

  const onClickEdit = id => {
    setEditingNotificationId(id)
  }

  const onClickView = id => {
    history.push(`/utility/general-notifications/view/${id}`)
  }

  const onClickDelete = async id => {
    try {
      await tintucStore.delete(id)

      message.success('Xóa thông báo thành công!')

      if (newsList.length === 1 && page > 1) {
        setPage(page - 1)
      }

      await loadTinTuc()
    } catch (err) {
      console.log(err)
      message.success(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handlePaginationChange = (newPage, newPageSize) => {
    setPage(newPage)
  }

  const menuControlNotification = id => {
    return (
      <Menu>
        {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__NEWS) && (
          <OverlayPanelWrapper
            renderOverlayPanel={(open, setOpen) => (
              <AddEditNotificationModalV2
                open={open}
                setOpen={setOpen}
                selectedNotificationId={id}
                onRefresh={async () => {
                  await loadTinTuc()
                  setSelectedKey(id.toString())
                }}
              />
            )}>
            <Menu.Item
              style={{ color: blue, backgroundColor: 'white' }}
              icon={<Pen2OutlineIcon style={{ width: 16, height: 16 }} />}>
              Sửa thông tin
            </Menu.Item>
          </OverlayPanelWrapper>
        )}
        {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__NEWS) && (
          <Menu.Item
            onClick={() => {
              onClickDelete(id)
            }}
            danger
            icon={<TrashBin2OutlineIcon style={{ width: 16, height: 16 }} />}>
            Xóa
          </Menu.Item>
        )}
      </Menu>
    )
  }

  useEffect(() => {
    setSelectedKey(newsList?.[0]?.id?.toString())
  }, [newsList])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Thông báo chung</title>
      </Helmet>
      <AppPageHeader
        title="Thông báo chung"
        addon={
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__NEWS}>
            <OverlayPanelWrapper
              renderOverlayPanel={(open, setOpen) => (
                <AddEditNotificationModalV2
                  open={open}
                  setOpen={setOpen}
                  selectedNotificationId={null}
                  onRefresh={() => loadTinTuc()}
                />
              )}>
              <Button
                className="icon-btn"
                icon={
                  <AddCircleOutlineIcon
                    style={{ color: '#fff', width: 16, height: 16 }}
                  />
                }
                type={'primary'}>
                Đăng thông báo
              </Button>
            </OverlayPanelWrapper>
          </AccessControlAction>
        }
      />

      <Spin spinning={isLoadingTinTuc}>
        {!newsList?.length ? (
          <EmptyContent />
        ) : (
          <>
            <Tabs
              activeKey={selectedKey}
              onChange={key => {
                setSelectedKey(key.toString())
              }}
              tabPosition={'left'}
              className="custom-ant-vertical-tabs">
              {(newsList || []).map(item => {
                return (
                  <TabPane
                    key={item.id}
                    tab={
                      <div style={{ display: 'flex', gap: 12 }}>
                        <Avatar
                          onError={() => true}
                          size={32}
                          src={item?.author?.image}
                          style={{
                            flexShrink: 0,
                            backgroundColor: '#60A5FA',
                          }}>
                          {item?.author?.name_lowercase
                            ?.charAt(0)
                            ?.toUpperCase()}
                        </Avatar>
                        <div>
                          <div
                            style={{
                              textTransform: 'capitalize',
                              fontWeight: 600,
                            }}>
                            {trimOverlengthString(
                              item?.author?.name_lowercase,
                              180
                            )}
                          </div>

                          <TextWrap>
                            {trimOverlengthString(item?.subject, 180)}
                          </TextWrap>
                        </div>
                      </div>
                    }>
                    <div
                      style={{
                        backgroundColor: '#F6F6F6',
                        borderRadius: 16,
                        padding: 20,
                      }}>
                      <div
                        style={{
                          backgroundColor: 'white',
                          borderRadius: 16,
                          padding: '0 20px 20px 20px',
                          height: '72dvh',
                          overflow: 'auto',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                            backgroundColor: 'white',
                            paddingTop: 20,
                          }}>
                          <h3
                            style={{
                              fontSize: '20px',
                              fontWeight: '600',
                              margin: 0,
                            }}>
                            {item?.subject}
                          </h3>

                          <Dropdown
                            overlay={() => menuControlNotification(item.id)}
                            placement="bottomLeft"
                            arrow
                            trigger={['click']}>
                            <Button
                              style={{ width: 40, height: 40, flexShrink: 0 }}
                              icon={
                                <MenuDotsBoldIcon
                                  style={{
                                    width: 20,
                                    height: 20,
                                    transform: 'rotate(90deg)',
                                  }}
                                />
                              }
                              className="custom-ant-button icon-btn"
                              type="text"
                              shape="circle"
                            />
                          </Dropdown>
                        </div>
                        <Divider style={{ margin: '24px 0' }} />

                        {WordBreak(item.content, true)}

                        {!!item?.attachments?.length && (
                          <>
                            <Divider style={{ margin: '24px 0' }} />
                            <div style={{ display: 'flex' }}>
                              <span
                                style={{
                                  margin: '10px 10px 15px 0px',
                                  fontWeight: 'bold',
                                  display: 'block',
                                }}>
                                Tài liệu đính kèm:
                              </span>
                              <ul
                                style={{
                                  margin: '10px 0 15px',
                                  paddingLeft: 0,
                                }}>
                                {(item?.attachments || []).map(file => (
                                  <FileItem
                                    key={file.file_id}
                                    file_id={file.file_id}
                                    file_name={file.file_name}
                                    file_type={utils.getExtensionFile(
                                      file.file_name
                                    )}
                                  />
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </TabPane>
                )
              })}
            </Tabs>

            <AppTablePagination
              total={totalCount}
              current={page}
              pageSize={10}
              onChange={handlePaginationChange}
              showSizeChanger={false}
              hideOnSinglePage={true}
              showQuickJumper={false}
            />
          </>
        )}
      </Spin>
    </DashboardLayout>
  )
}

TinTucPage.propTypes = {}

export default memo(
  inject(
    'tintucStore',
    'loadingAnimationStore',
    'authenticationStore',
    'commonStore',
    'history',
    'aclStore'
  )(observer(TinTucPage))
)
